import type { ConfigEnvironment, Environment, LocalizedPageForms } from '@env/types.environment';
import { EnvironmentTargetMap } from '@kerberos-compliance/compliance-shared-ui';
import { version } from '../../package.json';

/**
 * JOTFORM formIds
 */
const forms: LocalizedPageForms = {
  en: {
    'kyc-home': '231274201998358',
    'academy-home': '231515163359354',
    'contact-home': '231275364295359',
    faq: {
      'money-laundering': '231832551523047',
      academy: '231832968754065',
      'aml-desk': '231832916406052',
      'risk-analysis': '231832936804056',
      'kyc-app': '231832648514054',
    },
    feedback: '232571266309356',
  },
  de: {
    'kyc-home': '231274201998358',
    'academy-home': '231515163359354',
    'contact-home': '231275364295359',
    faq: {
      'money-laundering': '231832702025042',
      academy: '231832737268059',
      'aml-desk': '231832234461046',
      'risk-analysis': '231832415178052',
      'kyc-app': '231832153415045',
    },
    feedback: '232483877576069',
  },
};

/**
 * App Configurations.
 */
const config: ConfigEnvironment = {
  sentry_dsn: 'https://d65cb369e8f00a37751ebb037b8c4f9f@o4509134614822912.ingest.de.sentry.io/4509134696611920',
  adminDeskBaseUrl: 'https://stage.admin.aml-desk.eu',
  baseUrl: 'https://stage.www.aml-desk.eu',
  adpHost: {
    url: 'https://stage.api.aml-desk.eu',
    signIn: 'sign-in',
  },
  forms,
  // The tenant is needed on the very first request when creating a user, before any grant is known
  tenant: '075895c1-7491-48da-9875-a35c1a0379a5',
  hanko: {
    apiUrl: 'https://login.stage.aml-desk.eu',
    passkeyLimit: 10,
  },
  registrationGuideDocGoAml: 'https://storage.googleapis.com/risk-analysis-templates/Leitfaden_Registrierung_goAML.pdf',
  defaultOrganizationRiskAnalysisIdentifier: '01b062c3-d964-4ead-a347-45ffe2e983cd',
  maintenanceInfoUrl:
    'https://storage.googleapis.com/download/storage/v1/b/status.admin.aml-desk.eu/o/aad-stage.json?alt=media', // bucket is on 'keb-production', the same bucket is used for all environments
  academyUrl: 'https://academy.kerberos-compliance.com/ui/login',
};

export const environment: Environment = {
  productionBuild: true,
  target: EnvironmentTargetMap.Stage,
  debugFlags: [],
  config,
  version,
};
